const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  adminSign: state => state.user.adminSign,
  roles: state => state.user.roles,
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers,
  messageDataObj: state => state.user.messageDataObj,

}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js